import { checkEmailValidity } from "../emailBlocking";
import { messages } from "../utils";

export const isEmailValid = (form) => {
    const email = form.vals().Email;
    const country = form.vals().Country;

    if (!email || !country) return;

    if (!checkEmailValidity(email.toLowerCase(), country)) {
        const emailInput = form.getFormElem().find("#Email");
        const { emailValidationError } = messages;

        form.showErrorMessage(emailValidationError, emailInput);

        form.submitable(false);
    } else {
        form.submitable(true);
    }
};
